// extracted by mini-css-extract-plugin
export var container = "_64-0";
export var error = "_64-9";
export var label = "_64-5";
export var light = "_64-6";
export var md = "_64-3";
export var sm = "_64-2";
export var thin = "_64-8";
export var thinBold = "_64-7";
export var vertical = "_64-4";
export var xs = "_64-1";